MOVE.MORTGAGE.RATES.SORT_VIEW = (function() {
  var props;

  var init = function(propsRef) {
    props = propsRef;
  };

  var render = function() {
    // Nothing to render
  };

  var bind = function() {
    // Sort change
    if (MOVE.Helper.isPhone()) {
      $('.js-sort-select').on('change', handleSortMobile);
    } else {
      $('.js-sort a').on('click', handleSortDesktop);
    }
  };

  var handleSortDesktop = function (e) {
    e.preventDefault();
    if ($(this).hasClass('btn')) return;
    // Change active
    $('.js-sort a').removeClass('active');
    $(this).addClass('active');
    // Set props
    props.pagination.page = 1;
    props.sort = $(this).data('value');
    // Render
    $('body').trigger('rates.displayCards');
  };

  var handleSortMobile = function () {
    // Set props
    props.pagination.page = 1;
    props.sort = $(this).val();
    // Render
    $('body').trigger('rates.displayCards');
  };

  MOVE.MORTGAGE.RATES.SORT_VIEW = {
    init: init,
    render: render,
    bind: bind,
    actions: {

    }
  };

  return MOVE.MORTGAGE.RATES.SORT_VIEW;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/views/sort_view.js